import { __awaiter } from "tslib";
import React from 'react';
import axios from 'axios';
const LS6ProductionHost = 'https://labsimapi.testout.com/api/v1/lmsapp';
const LS6StageHost = 'https://testout-wwwsvc-staging.azurewebsites.net/OrbisPartner';
const LS6DevHost = 'https://localhost.testout.com:44344/api/v1/lmsapp';
const LS6TestHost = 'https://labsimapi-test.testout.com/api/v1/lmsapp';
// commonly meaning no selection in LS6
export const NoSelectionIndicator = '0';
// @ts-ignore
export const StateContext = React.createContext(null);
export default class LabSimService {
    // = axios.create({
    //    baseURL: process.env.REACT_APP_PARTNERS_ENDPOINT as string,
    // });
    static getContentServerUri() {
        if (this._ls6Host === LS6ProductionHost || this._ls6Host === LS6TestHost) {
            return 'https://testoutlivecontent.blob.core.windows.net';
        }
        else if (this._ls6Host === LS6StageHost) {
            return 'https://testoutlivecontent.blob.core.windows.net';
        }
        else if (this._ls6Host === LS6DevHost) {
            return 'https://testoutlivecontent.blob.core.windows.net';
        }
        else {
            return 'https://cdn.testout.com';
        }
    }
    static getLS6Target() {
        if (this._ls6Host === LS6ProductionHost) {
            return '';
        }
        else if (this._ls6Host === LS6StageHost) {
            return ' (Stage)';
        }
        else if (this._ls6Host === LS6DevHost) {
            return ' (Local)';
        }
        else if (this._ls6Host === LS6TestHost) {
            return ' (Test)';
        }
        else {
            return ' (x)';
        }
    }
    static setApiEndpoints(serverState) {
        if (serverState.labsimApiEndpoint === undefined || serverState.labsimApiEndpoint === null) {
            const ls6HostUrl = new URL(LabSimService._ls6Host);
            serverState.labsimApiEndpoint = ls6HostUrl.origin; //LabSimService._ls6Host;
        }
        if (serverState.partnersApiEndpoint === undefined ||
            serverState.partnersApiEndpoint === null) {
            serverState.partnersApiEndpoint = new URL(process.env.REACT_APP_PARTNERS_ENDPOINT).origin;
        }
        const jwtAuth = localStorage.getItem('JwtToken');
        this._partners = axios.create({
            baseURL: serverState.partnersApiEndpoint,
            headers: jwtAuth
                ? {
                    Authorization: `Bearer ${jwtAuth}`,
                }
                : undefined,
        });
        this._ls6 = axios.create({
            baseURL: serverState.labsimApiEndpoint + '/api',
        });
    }
    static getState(state) {
        return __awaiter(this, void 0, void 0, function* () {
            state = state.substr(4);
            this._state = state;
            sessionStorage.setItem('state', JSON.stringify(this._state));
            const stateId = this.getStoredState();
            try {
                const response = yield LabSimService._ls6StateHost.get(`/state/${stateId}`);
                return response.data;
            }
            catch (error) {
                console.log(error);
            }
        });
    }
    static getProducts() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                if (this._ls6 === null) {
                    return Promise.reject('LS6 is not initialized');
                }
                else {
                    const productData = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v2/lmsapp/products/${stateId}`));
                    return productData === null || productData === void 0 ? void 0 : productData.data;
                }
            }
            catch (error) {
                console.log(error);
            }
        });
    }
    static getCustomExams() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const customExamData = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/customexamsdata/${stateId}`));
                return customExamData === null || customExamData === void 0 ? void 0 : customExamData.data;
            }
            catch (error) {
                console.log(error);
            }
        });
    }
    static assignmentGroups() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const canvasData = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/assignmentgroups/${stateId}`));
                return Promise.resolve(canvasData === null || canvasData === void 0 ? void 0 : canvasData.data);
            }
            catch (error) {
                return Promise.reject(error);
            }
        });
    }
    static getActiveExamsVersion(isbns) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const requestBody = {
                    stateId: stateId,
                    isbn: isbns,
                };
                const canvasData = yield ((_a = LabSimService._partners) === null || _a === void 0 ? void 0 : _a.post(`/plugin/allcurrentversions`, requestBody));
                return Promise.resolve(canvasData === null || canvasData === void 0 ? void 0 : canvasData.data);
            }
            catch (error) {
                return Promise.reject(error);
            }
        });
    }
    static getCampusActiveProductVersionIsbn(isbn) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const canvasData = yield ((_a = LabSimService._partners) === null || _a === void 0 ? void 0 : _a.get(`/plugin/currentversion/${stateId}/${isbn}`));
                return Promise.resolve(canvasData === null || canvasData === void 0 ? void 0 : canvasData.data);
            }
            catch (error) {
                return Promise.reject(error);
            }
        });
    }
    static getCampusActiveProductVersion(productId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const canvasData = yield ((_a = LabSimService._partners) === null || _a === void 0 ? void 0 : _a.get(`/advantage/v1/currentversion/${stateId}/${productId}`));
                return Promise.resolve(canvasData === null || canvasData === void 0 ? void 0 : canvasData.data);
            }
            catch (error) {
                return Promise.reject(error);
            }
        });
    }
    static getSections(productVersionId) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (this._outlineCache.has(productVersionId)) {
                return Promise.resolve(this._outlineCache.get(productVersionId));
            }
            const stateId = this.getStoredState();
            try {
                const sectionData = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/outline/${stateId}/${productVersionId}`));
                if (((_b = sectionData === null || sectionData === void 0 ? void 0 : sectionData.data) === null || _b === void 0 ? void 0 : _b.success) === true) {
                    const data = (_c = sectionData === null || sectionData === void 0 ? void 0 : sectionData.data) === null || _c === void 0 ? void 0 : _c.toc;
                    this._outlineCache.set(productVersionId, data);
                    return Promise.resolve(data);
                }
                else {
                    return Promise.reject((_d = sectionData === null || sectionData === void 0 ? void 0 : sectionData.data) === null || _d === void 0 ? void 0 : _d.errorMessage);
                }
            }
            catch (error) {
                return Promise.reject(error);
            }
        });
    }
    static syncGrades(isSyncLate, isMarkLate, isCheckLockDates) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            const syncRequest = {
                checkLockDates: isCheckLockDates,
                markLate: isMarkLate,
                state: stateId,
                syncLate: isSyncLate,
            };
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.post('/v1/lmsapp/syncscores', syncRequest));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static manualSyncGrades() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            if (stateId === null) {
                return Promise.reject(new Error('State is not initialized'));
            }
            const syncRequest = {
                state: stateId,
            };
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.post('/v1/lmsapp/manualsync', syncRequest));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static advantageManualSyncGrades(classProfileId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            if (stateId === null) {
                return Promise.reject(new Error('State is not initialized'));
            }
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.post(`/v1/lmsapp/advantage/syncs/${stateId}?classProfileId=${classProfileId}`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static advantageSyncStatus(classProfileId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/advantage/syncs/${stateId}/status?classProfileId=${classProfileId}`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static syncStatus() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/syncstatus/${stateId}`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static getAutomaticSyncSettings() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/automaticsyncsettings/${stateId}`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static getMyClasses() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/myclasses/${stateId}`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static getClassLockedVersions() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/classes/${stateId}/lockedversions`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static getAdvantageSyncHistory() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/advantage/syncs/${stateId}/history`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static getCurrentUser() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/advantage/syncs/${stateId}/user`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static getAllFeatureFlags(userProfileId, campusProfileId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            const ls6Client = this._partners;
            if (!ls6Client) {
                return Promise.reject('LS6 is not initialized');
            }
            const path = campusProfileId
                ? `/v1/lmsapp/features/${userProfileId}/all/${campusProfileId}`
                : `/v1/lmsapp/features/${userProfileId}/all`;
            try {
                const response = yield ls6Client.get(path, { params: { stateId } });
                return Promise.resolve(((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : {}));
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static getStudentsInClass(classProfileId, search = '', page = 1, pageSize = 25) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const params = new URLSearchParams({
                    classProfileId,
                    page: String(page),
                    pageSize: String(pageSize),
                });
                if (search) {
                    params.set('search', search);
                }
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/advantage/syncs/${stateId}/students?${params.toString()}`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static getStudentAssignments(studentId, classProfileId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const params = new URLSearchParams({ classProfileId });
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/advantage/syncs/${stateId}/students/${studentId}/assignments?${params.toString()}`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static syncStudentGrades(studentId, classProfileId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const params = new URLSearchParams({ classProfileId });
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.post(`/v1/lmsapp/advantage/syncs/${stateId}/students/${studentId}?${params.toString()}`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static searchInstructors(search = '') {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const params = new URLSearchParams();
                if (search) {
                    params.set('search', search);
                }
                const query = params.toString();
                const url = `/v1/lmsapp/advantage/syncs/${stateId}/instructors${query ? `?${query}` : ''}`;
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(url));
                return Promise.resolve(((_b = response === null || response === void 0 ? void 0 : response.data) !== null && _b !== void 0 ? _b : []));
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static getClassesForInstructor(instructorId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            try {
                const params = new URLSearchParams({ instructorId });
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/advantage/syncs/${stateId}/classes?${params.toString()}`));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static updateAutomaticSyncSettings(active, includeLate, includeUnavailable) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const stateId = this.getStoredState();
            const syncRequest = {
                stateId: stateId,
                isFeatureEnabled: false,
                isLatestGradeEnabled: false,
                isActive: active,
                isIncludeLate: includeLate,
                isIncludeNotAvailable: includeUnavailable,
            };
            try {
                const response = yield ((_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.post('/v1/lmsapp/automaticsyncsettings', syncRequest));
                return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
            }
            catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        });
    }
    static createResourceAssignments(selectedResources, createCallback, errorCallback) {
        var _a;
        const stateId = this.getStoredState();
        if (stateId !== null) {
            selectedResources.state = stateId;
        }
        (_a = LabSimService._partners) === null || _a === void 0 ? void 0 : _a.post('/plugin/assignments', selectedResources).then((response) => {
            if (createCallback) {
                createCallback(response.data);
            }
        }).catch((err) => {
            if (errorCallback) {
                errorCallback(err.message);
            }
        });
    }
    static createCustomExamAssignment(selectedResource, createCallback, errorCallback) {
        var _a;
        const stateId = this.getStoredState();
        if (stateId !== null) {
            selectedResource.state = stateId;
        }
        (_a = LabSimService._partners) === null || _a === void 0 ? void 0 : _a.post('/plugin/assignments', selectedResource).then((response) => {
            if (createCallback) {
                createCallback(response.data);
            }
        }).catch((err) => {
            if (errorCallback) {
                errorCallback(err.message);
            }
        });
    }
    static createCertificationAssignment(selectedResources, createCallback, errorCallback) {
        var _a;
        const stateId = this.getStoredState();
        if (stateId !== null) {
            selectedResources.state = stateId;
        }
        (_a = LabSimService._partners) === null || _a === void 0 ? void 0 : _a.post('/plugin/assignments', selectedResources).then((response) => {
            if (createCallback) {
                createCallback(response.data);
            }
        }).catch((err) => {
            if (errorCallback) {
                errorCallback(err.message);
            }
        });
    }
    static getHelpUrl() {
        var _a, _b;
        const stateId = this.getStoredState();
        return ((_b = (_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.get(`/v1/lmsapp/gethelpurl/${stateId}`)) !== null && _b !== void 0 ? _b : Promise.reject('LS6 is not initialized'));
    }
    static saveHelpUrl(schoolGuid, helpUrl) {
        var _a;
        const stateId = this.getStoredState();
        const formData = new FormData();
        formData.append('schoolGuid', schoolGuid);
        formData.append('helpUrl', helpUrl);
        (_a = LabSimService._ls6) === null || _a === void 0 ? void 0 : _a.post(`/v1/lmsapp/sethelpurl/${stateId}`, formData);
    }
    static getStoredState() {
        const state = sessionStorage.getItem('state');
        if (state) {
            this._state = JSON.parse(state);
        }
        return this._state;
    }
    static openSyncLog(RequestGuid) {
        const detailUrl = `${LabSimService._ls6Host}/opensynclog/${RequestGuid}`;
        window.open(detailUrl, '_blank');
    }
    static getDefaultResourceLink(productVersionId) {
        return LabSimService._ls6.get(`/v1/lmsapp/products/${productVersionId}/resources/default`);
    }
    static getDynamicRegistration(id) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this._partners === null) {
                this._partners = axios.create({
                    baseURL: process.env.REACT_APP_PARTNERS_ENDPOINT,
                });
            }
            const response = yield ((_a = LabSimService._partners) === null || _a === void 0 ? void 0 : _a.get(`/openid/dynamicregistration/${id}`));
            return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
        });
    }
    static postDynamicRegistration(id) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this._partners === null) {
                this._partners = axios.create({
                    baseURL: process.env.REACT_APP_PARTNERS_ENDPOINT,
                });
            }
            const response = yield ((_a = LabSimService._partners) === null || _a === void 0 ? void 0 : _a.post(`/openid/register/${id}`));
            return Promise.resolve(response === null || response === void 0 ? void 0 : response.data);
        });
    }
    static getLocaleOptions(getTestLanguages = false) {
        return LabSimService._ls6.get(getTestLanguages ? '/v1/locales?debug=true' : '/v1/locales').then((res) => res.data);
    }
}
LabSimService._state = null;
LabSimService._ls6Host = process.env.REACT_APP_LS6API_ENDPOINT;
LabSimService._ls6 = null;
//  = axios.create({
//    baseURL: LabSimService._ls6Host,
// });
LabSimService._ls6StateHost = axios.create({
    baseURL: LabSimService._ls6Host,
});
LabSimService._partners = null;
// in-memory cache
LabSimService._outlineCache = new Map();
//# sourceMappingURL=LabSimService.js.map